// extracted by mini-css-extract-plugin
export default {"accordion":"ManageOrderDetail_accordion__v3W52"};